// @flow

export const statuses = Object.freeze({
  All: 'all',
  Pending: 'pending',
  Spent: 'spent',
  Removed: 'removed',
});

export type Status = $Values<typeof statuses>;
